import React from 'react'
import PropTypes from 'prop-types'
import {findDOMNode} from "react-dom"
import TaskStatusSelectorPopover from "./popover"
import PopoverPosition from "../../../gd-components/gd-popover/popover-position"
import HintPopover from "../../hint-popover/hint-popover"
import TaskStatusManager from "../../../gd/manager/task-status-manager"
import TaskWorkflow from "../../../model2/status/task-workflow"
import ColorBlock26 from "./render/color-block-26"
import Status from "../../../model2/status/status"
import TaskStatusSelector_TaskReply from "./render/task-reply"
import TaskStatusSelector_UI5 from "./render/ui5"
import TaskStatusSelector_Form from "./render/form"
import ColorBlock28 from "./render/color-block-28"

export enum TaskStatusSelectorRender {
    COLOR_BLOCK_28  = 'color-block-28',
    COLOR_BLOCK_26  = 'color-block-26',
    TASK_REPLY      = 'task-reply',
    UI5             = 'ui5',
    FORM            = 'form',
    CONTROL_BUTTON  = 'control-button-24',
    FUNC            = 'function',
}

// const debug = "TaskStatusSelector_v2"
const debug = false

export default class TaskStatusSelector_v2 extends React.Component<any,any> {

    private _workflow    : TaskWorkflow | null


    static propTypes = {
        task: PropTypes.any,  // task model

        workflow    : PropTypes.any,

        statusId    : PropTypes.any,    // values to be used instead of task.statusId

        // taskTypeId: PropTypes.string,                   // task type ID
        // value: PropTypes.string,                        // current statusId
        autoSelectStatus: PropTypes.bool,               // select first available status from list if no value

        // Display customizations
        placeholder: PropTypes.string,                  // can be used when no status i.e. re-open task (hotya tam mozno i pervii kstati brat' avtomatom !
        hint: PropTypes.bool,                           // if true - show hint messages

        popoverHint: PropTypes.string,

        // callbacks
        onUserSelect: PropTypes.func,
        onChange: PropTypes.func,
        onTogglePopover: PropTypes.func,                // hez zachem no vezde est'
        onAutoSelect: PropTypes.func,                   // is called if autoSelectStatus enabled and some status auto selected

        // look and feel
        renderValue: PropTypes.oneOf(
            [
                TaskStatusSelectorRender.COLOR_BLOCK_28,
                TaskStatusSelectorRender.COLOR_BLOCK_26,
                TaskStatusSelectorRender.TASK_REPLY,
                TaskStatusSelectorRender.FORM,
                TaskStatusSelectorRender.UI5,
                TaskStatusSelectorRender.CONTROL_BUTTON,
                TaskStatusSelectorRender.FUNC,
            ]).isRequired, // render value view name


        renderValueFunc: PropTypes.func,        // func for external render function if passwed used to render instead of default

        // options: PropTypes.array.isRequired,
        disabled: PropTypes.bool,                       // if true not editable (!) just view maybe right name is editable not disabled ?

        attachment: PropTypes.string,
        targetAttachment: PropTypes.string,
        targetOffset: PropTypes.string,
        attachmentType: PropTypes.string, //full, horizontal, vertical

    };

    static defaultProps = {
        autoSelectStatus: false,
        hint: true,

        placeholder: 'Select status',

        disabled: false,

        attachment: "top right",
        targetAttachment: "top left",
        targetOffset: "0 0",
        attachmentType: "full",
    };

    constructor(props:any) {
        super(props);

        this._workflow       = _.get(props,'workflow', null)

        this.state = {
            showPopover     : false,
            value           : this.initValue(this.props)
        };
    }

    // if rerender with new value
    UNSAFE_componentWillReceiveProps(nextProps:any) {
        if (this.state.value !== nextProps.value) {
            this.setState({
                value: this.initValue(nextProps)
            });
        }
    }

    get workflow() {
        if (!this._workflow) {
            this._workflow = TaskStatusManager.getWorkflow(this.props.task)
        }
        return this._workflow
    }

    private initValue = (props:any) => {

        if (props.statusId) {
            debug && console.log(debug, "initValue on props.statusId", props)
            return props.statusId
        }

        if (props.task) {
            debug && console.log(debug, "initValue on task.statusId")
            return props.task.statusId
        }


        if (props.autoSelectStatus ) {
            console.error("TODO #444")

            const taskStatuses = TaskStatusManager.getTaskStatuses({projectId:props.projectId, taskTypeId:props.taskTypeId});

            const orderedOpenStatuses = _.chain(taskStatuses)
                .filter(m=>![gd.const.systemStatus.COMPLETED, gd.const.systemStatus.CANCELLED].includes(m.systemStatus))
                .sortBy("systemStatus")
                .value();

            const res = orderedOpenStatuses[0] ? orderedOpenStatuses[0].id : null;
            if(this.props.onAutoSelect) this.props.onAutoSelect(res);

            return res
        }

        return null
    };

    // Checkbox
    onCheckboxClick = (e:React.SyntheticEvent):void => {
        if (this.props.disabled) return;

        e.stopPropagation();


        // ok we clicked checkbox
        const status = gd.session.statuses.get(this.state.value);
        let newStatus;

        if (gd.const.systemStatus.isOpen(status.systemStatus)) {
            newStatus = this.workflow.getDefaultClosedStatus()
        } else {
            // we need to reopen
            newStatus = this.workflow.getDefaultOpenStatus()
        }

        if (!newStatus) return

        this.onStatusClick(newStatus?.id)
    }

    togglePopover = (e?:React.SyntheticEvent) => {
        if (e) e.stopPropagation();

        if (this.props.disabled) return

        const showPopover = !this.state.showPopover;

        this.setState({
            showPopover: showPopover
        },()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(showPopover);
        });
    }

    hidePopover = (statusId?:ID) => {
        this.setState({
            showPopover : false,
            value       : statusId ? statusId : this.state.value
        });
        if (this.props.onTogglePopover) this.props.onTogglePopover(false);
    }

    onStatusClick = (statusId:ID) => {
        let { onUserSelect, options } = this.props;

        let curStatus = _.find(options, (o) => o.value === this.state.value);
        if (!curStatus) curStatus = gd.session.statuses.get(this.state.value);

        if (curStatus && gd.const.systemStatus.isClosed(curStatus.systemStatus)) {
            this.hidePopover();
        } else {
            this.hidePopover(statusId);
        }
        if (onUserSelect) onUserSelect(statusId, this.confirmCallback);
    }

    confirmCallback = (value:ID, actionRequiredUserId:ID) => {
        let prevValue = this.state.value;
        this.setState({
            showPopover: false,
            value: value
        });

        let { onChange } = this.props;
        if (onChange) onChange(prevValue, value, actionRequiredUserId);
    }

    renderPopover() {


        const popoverPosition = new PopoverPosition({
            attachment          : this.props.attachment,
            targetAttachment    : this.props.targetAttachment,
            targetOffset        : this.props.targetOffset,
            attachmentType      : this.props.attachmentType,
            constraints         : [{
                to: "window",
                attachment: "together",
                pin: true,
            }]
        })

        return (
                <TaskStatusSelectorPopover hidePopover={this.hidePopover}
                                           task={this.props.task}
                                           workflow={this.workflow}
                                           onStatusSelect={this.onStatusClick}
                                           togglePopover={this.togglePopover}
                                           hint={this.props.hint}
                                           popoverPosition={popoverPosition}
                                           getTarget={()=>findDOMNode(this)}
                />
        )
    }

    _getValues = () => {
        // value label
        let valueLabel  = this.props.placeholder;
        let statusColor = 1;
        let isOpen      = true;

        if (this.state.value) {
            const status = gd.session.statuses.get(this.state.value);

            if (status) {
                valueLabel = status.name;
                statusColor = status.color;
                isOpen = gd.const.systemStatus.isOpen(status.systemStatus);
            }
        }

        return {valueLabel, statusColor, isOpen};
    }

    private get currentStatus() {
        if (this.state.value) {
            return gd.session.statuses.get(this.state.value);
        }

        // eslse return duymmy status
        return new Status({
            id              : 'fake-id',
            color           : 1,
            name            : this.props.placeholder,
            systemStatus    : 1
        })
    }

    renderValue() {
        const {valueLabel, statusColor, isOpen} = this._getValues();

        let curValueClasses;
        let checkboxValue   : any = false;

        switch (this.props.renderValue) {

            case 'table-inline':
                curValueClasses = Classes('cur-value', 'table-inline-type', 'gd-scf-'+statusColor);

                return (
                    <div className={curValueClasses}>
                        <div className="name">{valueLabel}</div>
                    </div>
                );

            case 'task-view':
                curValueClasses = Classes('cur-value', 'task-view', 'status-color-'+statusColor );

                if (!isOpen) checkboxValue = <span className="i5-checkbox-ok"> </span>;

                return (
                    <div className={curValueClasses}>
                        {!this.props.disabled &&
                        <div className="checkbox" onClick={this.onCheckboxClick}>{checkboxValue}</div>}

                        <div className="name">{valueLabel}</div>
                        <span className="i5-big-angle-down"> </span>

                    </div>
                );

            case 'task-view-inline':
                curValueClasses = Classes('cur-value', 'task-view-inline', 'gd-scf-'+statusColor, {
                    'disabled': this.props.disabled
                });

                if (!isOpen) checkboxValue = <span className="i5-checkbox-ok"> </span>;

                return (
                    <div className={curValueClasses}>
                        {!this.props.disabled &&
                        <div className="checkbox" onClick={this.onCheckboxClick}>{checkboxValue}</div>}

                        <div className="name">{valueLabel}</div>
                        <span className="i5-big-angle-down"> </span>

                    </div>
                );

            case TaskStatusSelectorRender.COLOR_BLOCK_26:
            case TaskStatusSelectorRender.COLOR_BLOCK_28:
                curValueClasses = Classes('cur-value', this.props.renderValue, 'status-color-'+statusColor );
                if (!isOpen) checkboxValue = <span className="i5-checkbox-ok"> </span>;

                const checkboxClasses = (isOpen)?'checkbox':'checkbox checked';

                return (
                    <div className={curValueClasses}>
                        <div className={checkboxClasses} onClick={this.onCheckboxClick}>{checkboxValue}</div>
                        <div className="name">{valueLabel}</div>
                        <span className="i5-big-angle-down"> </span>

                    </div>
                );

            case 'color-round-block-22':
                curValueClasses = Classes('cur-value', 'color-round-block-22', 'status-color-'+statusColor );
                return (
                    <div className={curValueClasses}>
                        <div className="name">{valueLabel}</div>
                    </div>
                );

            case 'ui5':
            case 'ui5-18':
            case 'ui5-22':
                curValueClasses = Classes('ui5-status-list', 'status-c{0}'.f(statusColor), {
                    's18': this.props.renderValue === 'ui5-18',
                    's22': this.props.renderValue === 'ui5-22'
                });
                return (
                    <div className={curValueClasses}>
                        {valueLabel}
                    </div>
                );
        }
    }

    render() {

        const classes = Classes('gd-select-status', '{0}-type'.f(this.props.renderValue), this.props.className, {
            disabled: this.props.disabled
        });


        switch (this.props.renderValue) {

            case TaskStatusSelectorRender.FORM:
                return (
                    <div className={classes} onClick={this.togglePopover}>
                        <TaskStatusSelector_Form status={this.currentStatus} />
                        {this.state.showPopover && this.renderPopover()}
                        {this.props.popoverHint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.popoverHint}/>}
                    </div>
                )

            case TaskStatusSelectorRender.UI5:
                return (
                    <div className={classes} onClick={this.togglePopover}>
                        <TaskStatusSelector_UI5 status={this.currentStatus} />
                        {this.state.showPopover && this.renderPopover()}
                        {this.props.popoverHint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.popoverHint}/>}
                    </div>
                )

            case TaskStatusSelectorRender.CONTROL_BUTTON:
                return (
                    <div className={Classes("ui5-control-button s-24 fs-16 with-dot i5-status-with-dot", this.props.className)} onClick={this.togglePopover}>
                        <div className={Classes('color-dot', 'status-color-{0}'.f(this.currentStatus.color))}/>
                        {this.state.showPopover && this.renderPopover()}
                        {this.props.popoverHint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.popoverHint}/>}
                    </div>
                )


            case TaskStatusSelectorRender.COLOR_BLOCK_26: {
                this.workflow.applyACL(this.props.task)

                let checkBoxStatus : Status | null = null
                if (this.props.task.isOpen) {
                    checkBoxStatus = this.workflow.getDefaultClosedStatus()
                } else {
                    checkBoxStatus = this.workflow.getDefaultOpenStatus()
                }

                return (
                    <div className={classes} onClick={this.togglePopover}>
                        <ColorBlock26 status={this.currentStatus} onCheckboxClick={this.onCheckboxClick} checkboxStatus={checkBoxStatus}/>
                        {this.state.showPopover && this.renderPopover()}
                        {this.props.popoverHint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.popoverHint}/>}
                    </div>
                )
            }

            case TaskStatusSelectorRender.COLOR_BLOCK_28: {
                this.workflow.applyACL(this.props.task)

                let checkBoxStatus : Status | null = null
                if (this.props.task.isOpen) {
                    checkBoxStatus = this.workflow.getDefaultClosedStatus()
                } else {
                    checkBoxStatus = this.workflow.getDefaultOpenStatus()
                }

                return (
                    <div className={classes} onClick={this.togglePopover}>
                        <ColorBlock28 status={this.currentStatus} onCheckboxClick={this.onCheckboxClick} checkboxStatus={checkBoxStatus}/>
                        {this.state.showPopover && this.renderPopover()}
                        {this.props.popoverHint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.popoverHint}/>}
                    </div>
                )
            }

            case TaskStatusSelectorRender.TASK_REPLY:

                const minimized = (this.state.value === this.props.task.statusId)

                return (
                    <div className={classes} onClick={this.togglePopover}>
                        <TaskStatusSelector_TaskReply minimized={minimized} status={this.currentStatus} onCheckboxClick={this.onCheckboxClick} />
                        {this.state.showPopover && this.renderPopover()}
                        {this.props.popoverHint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.popoverHint}/>}
                    </div>
                )

            case TaskStatusSelectorRender.FUNC:
                return this.props.renderValueFunc?.(this.props, this.state, (e: React.MouseEvent)=> {
                    this.togglePopover(e)
                },
                    <>
                        {this.state.showPopover &&
                            this.renderPopover()}

                        {this.props.popoverHint && !this.state.showPopover &&
                            <HintPopover hint={this.props.popoverHint}/>}
                    </>
                )

            default:
                return null
        }


        /*switch (this.props.renderValue) {
            case 'ui5-card':
                const {statusColor} = this._getValues();
                return (
                    <div className={Classes("action-button with-border with-dot i5-status-update", this.props.className)} onClick={this.togglePopover}>
                        <div className={Classes('colored-dot', 'status-color-{0}'.f(statusColor))}/>
                        {this.state.showPopover && this.renderPopover()}
                        {this.props.popoverHint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.popoverHint}/>}
                    </div>
                )

            case 'control-button-24':
            {
                const {statusColor} = this._getValues()
                return (
                    <div className={Classes("ui5-control-button s-24 fs-16 with-dot i5-status-with-dot", this.props.className)} onClick={this.togglePopover}>
                        <div className={Classes('color-dot', 'status-color-{0}'.f(statusColor))}/>
                        {this.state.showPopover && this.renderPopover()}
                        {this.props.popoverHint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.popoverHint}/>}
                    </div>
                )
            }
            default:
                return (
                    <div className={classes} onClick={this.togglePopover}>
                        {this.renderValue()}
                        {this.state.showPopover && this.renderPopover()}
                        {this.props.popoverHint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.popoverHint}/>}
                    </div>
                );
        }*/
    }
}